<template>
	<div>
		<CheckCircleIcon class="mx-auto size-16 text-won-green" />

		<h2 class="mt-6 text-center text-[20px] leading-[28px] font-semibold text-gray-900">
			Discount applied
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			Your subscription is confirmed. Starting
			<span class="font-medium text-gray-900">{{ formattedNextPaymentDate }}</span>, you’ll pay
			<span class="font-medium text-gray-900">{{ discountedPrice }}/month</span>
			for the next {{ months }} {{ months === 1 ? 'month' : 'months' }}.
			After that, it returns to {{ regularPrice }}/month.
		</p>

		<button
			type="button"
			class="
				mx-auto mt-6 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-won-green px-3 text-[16px] leading-[20px] font-medium text-white hover:bg-won-green-dark
			"
			@click="emit('dismiss')"
		>
			Got It!
		</button>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import moment from 'moment';
import { CheckCircleIcon } from '@heroicons/vue/24/outline';

import { formatPrice } from '../../../../utils/helpers';

/**
 * Every figure comes from the retention-offer accept response (EN-880) rather than the
 * copy in Figma: CAD plans exist and prices change, so nothing here may be hardcoded.
 */
const props = defineProps({
	nextPaymentDate: {
		type: String,
		required: true,
	},
	discountedAmount: {
		type: Number,
		required: true,
	},
	regularAmount: {
		type: Number,
		required: true,
	},
	currency: {
		type: String,
		required: true,
	},
	discountMonths: {
		type: Number,
		default: 3,
	},
});

const emit = defineEmits(['dismiss']);

const formattedNextPaymentDate = computed(() => moment(props.nextPaymentDate).format('MM/DD/YYYY'));
// The endpoint types `discount_months` as int|null (it reads the coupon's
// duration_in_months), so an explicit null falls back to the coupon's configured 3.
const months = computed(() => props.discountMonths ?? 3);
const discountedPrice = computed(() => formatPrice(props.discountedAmount, props.currency));
const regularPrice = computed(() => formatPrice(props.regularAmount, props.currency));
</script>
